let lightGalleryLib = null;
let plugins = {};

/**
 * GalleryManager контролює ініціалізацію та налаштування плагіна lightGallery.
 * Зараз галерея відпрацьовує на:
 * - слайдері з відгуками, який має відео
 * - Сторінка лоту
 * - Сторінка Hot-offer
 * - Cargo Tracking
 * - Tracking (Заглушка)
 */

const GalleryManager = {
  async init() {
    const hasThumbnails = document.querySelector('[data-lg-gallery-thumbnail]');
    const hasVideos = document.querySelector('[data-lg-video-after-click]');

    if (!hasThumbnails && !hasVideos) return;

    if (!lightGalleryLib) {
      const { default: lightGallery } = await import('lightgallery');
      lightGalleryLib = lightGallery;
    }

    if (hasThumbnails && (!plugins.zoom || !plugins.thumbnail)) {
      const [{ default: lgZoom }, { default: lgThumbnail }] = await Promise.all(
        [
          import('lightgallery/plugins/zoom'),
          import('lightgallery/plugins/thumbnail'),
        ],
      );
      plugins.zoom = lgZoom;
      plugins.thumbnail = lgThumbnail;
    }

    if (hasVideos && !plugins.video) {
      const { default: lgVideo } = await import('lightgallery/plugins/video');
      plugins.video = lgVideo;
    }

    this.initThumbnails();
    this.initVideos();
  },

  initThumbnails() {
    document
      .querySelectorAll('[data-lg-gallery-thumbnail]')
      .forEach((wrapper) => {
        if (wrapper.dataset.lgInitialized === 'true') return;

        const galleryEl = wrapper.querySelector(
          '[data-lg-gallery-thumbnail-wrap]',
        );
        if (!galleryEl) return;

        const instance = lightGalleryLib(galleryEl, {
          licenseKey: theme.credendionals.LIGHTGALLERY_LICENSE_KEY,
          plugins: [plugins.zoom, plugins.thumbnail],
          thumbnail: true,
          zoom: true,
          actualSize: false,
          showZoomInOutIcons: true,
          mobileSettings: {
            showCloseIcon: true,
            download: true,
          },
        });

        wrapper
          .querySelectorAll('[data-lg-gallery-thumbnail-start]')
          .forEach((btn) => {
            btn.addEventListener('click', () => {
              instance.openGallery(btn.dataset.lgGalleryThumbnailStart);
            });
          });

        wrapper.querySelector('[data-lg-gallery-thumbnail-overlay]')?.remove();
        wrapper.dataset.lgInitialized = 'true';
      });
  },

  initVideos() {
    document.querySelectorAll('[data-lg-video-after-click]').forEach((el) => {
      if (el.lightGallery) return;

      el.lightGallery = lightGalleryLib(el, {
        licenseKey: theme.credendionals.LIGHTGALLERY_LICENSE_KEY,
        selector: 'this',
        download: false,
        plugins: [plugins.video],
      });
    });
  },
};

export default GalleryManager;
